import { Control } from 'react-hook-form';
import { Grid, Box, Divider } from '../../../base';
import { useTranslation } from 'react-i18next';
import { StyledHeaderText } from './NotificationsTab.styles';
import { notificationSettings } from '../../../common';
import NotificationRow from './NotificationRow';

interface NotificationsTabProps {
    control: Control<any>;
}

const NotificationsTab = (props: NotificationsTabProps) => {
    const { control } = props;
    const { t } = useTranslation();

    return (
        <Grid container>
            <Grid item xs={12}>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={6}>
                        <StyledHeaderText variant="body2">
                            {t('settings.notifications.title')}
                        </StyledHeaderText>
                    </Grid>
                    <Grid item xs={3}>
                        <StyledHeaderText variant="body2" textAlign="center">
                            {t('settings.notifications.sms')}
                        </StyledHeaderText>
                    </Grid>
                    <Grid item xs={3}>
                        <StyledHeaderText variant="body2" textAlign="center">
                            {t('settings.notifications.email')}
                        </StyledHeaderText>
                    </Grid>
                </Grid>
                <Divider />
                {notificationSettings.map((notification, index) => (
                    <Box key={notification.key}>
                        <NotificationRow
                            notification={notification}
                            control={control}
                        />
                        {index < notificationSettings.length - 1 && <Divider />}
                    </Box>
                ))}
            </Grid>
        </Grid>
    );
};

export default NotificationsTab;
